import FormatoMonetario from "@/utils/FormatoMonetario.js";
export default {
  data() {
    return {
      anioVacanteTP: PLATAFORMA_TP.ANIO.VACANTE,
      anioArancelTP: PLATAFORMA_TP.ANIO.ARANCEL,
      anioMatriculaTP: PLATAFORMA_TP.ANIO.MATRICULA,
      anioVacanteU: PLATAFORMA_U.ANIO.VACANTE,
      anioArancelU: PLATAFORMA_U.ANIO.ARANCEL,
      anioMatriculaU: PLATAFORMA_U.ANIO.MATRICULA
    };
  },
  methods: {
    formatearArancelMatricula(monto, tipoMoneda) {
      /*if (tipoMoneda === "CLP") {
        return FormatoMonetario.getMontoEnMoneda(monto);
      } else {
        return `${FormatoMonetario.getFormatoNumerico(monto)} ${tipoMoneda}`;
      }*/
      if (monto === "-1") {
        return "Sin Información";
      }
      return FormatoMonetario.getArancelMatriculaFormateado(monto, tipoMoneda);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/FormatearArancelMatricula.js